import _extends from "@swc/helpers/src/_extends.mjs";
// DS: i7.8
import React from 'react';
import IconWrap from '../../IconWrap';
const RightAlign = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M4 6a1 1 0 001 1h9a1 1 0 000-2H5a1 1 0 00-1 1zm1 13h9a1 1 0 000-2H5a1 1 0 000 2zm0-6h14a1 1 0 000-2H5a1 1 0 000 2z",
        transform: "matrix(-1 0 0 1 24 0)"
    })));
};
RightAlign.displayName = 'RightAlign';
export default RightAlign;
